import { useQuery } from "@tanstack/react-query";

import { Team } from "~/api/Api";
import { apiClient } from "~/api/ApiClient";
import { tryCatch } from "~/helpers/tryCatch";
import { isWhiteLabel } from "~/utils/white-label";

export const teamsQueries = {
  all: ["teams"] as const,
};

export function useTeams() {
  return useQuery({
    enabled: !isWhiteLabel(),
    queryKey: teamsQueries.all,
    queryFn: async (): Promise<Team[]> => {
      const result = await tryCatch(apiClient.teams.teamsList());

      if (result.error) throw result.error;

      return result.data?.data?.teams ?? [];
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}
